export default __webpack_public_path__ + "static/media/about-us-section-three.334ec5d8.png";